window.naVersion = '2026-07-02.05';
